<template>
  <span :class="classes">
    <span v-if="!isDetermined"></span>
    <span v-else>
      <NbIcon
        v-if="percentLoaded && percentLoaded >= 75"
        symbol="progress-100"
        :color="color"
        :is-small="isSmall"
      />
      <NbIcon
        v-else-if="percentLoaded && percentLoaded >= 50"
        symbol="progress-75"
        :color="color"
        :is-small="isSmall"
      />
      <NbIcon
        v-else-if="percentLoaded && percentLoaded >= 25"
        symbol="progress-50"
        :color="color"
        :is-small="isSmall"
      />
      <NbIcon v-else symbol="progress-25" :color="color" :is-small="isSmall" />
    </span>
  </span>
</template>

<script setup lang="ts">
import '../scss/components/nb-loading.scss'
import NbIcon from './NbIcon.vue'
import { computed } from 'vue'
import type { NbLoadings } from './NbLoadings'
const props = withDefaults(defineProps<NbLoadings>(), {
  isDetermined: false,
  isSmall: false,
  color: 'primary'
})
const classes = computed(() => ({
  'nb-loading': true,
  [`nb-ct-${props.color}`]: true,
  'nb-loading-undetermined': !props.isDetermined,
  'nb-loading-xs': props.isSmall && !props.isDetermined,
  [`nb-loading-undetermined-${props.color}`]: !props.isDetermined && props.color !== 'primary'
}))
</script>
